import { useContext } from "react";

import { useTranslation } from "react-i18next";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import ActionToolbarButtonWrapper from "components/DesignComponents/Button/ActionToolbarButtonWrapper";
import TableContext from "context/table/tableContext";
import {
    COMPANY_LEVEL_SETTINGS,
    FEATURE_SETTINGS,
    useCompanyLevelSettings,
    useMediaQueries,
    usePermissions
} from "shared";

import CreateRole from "../dialogs/Roles/CreateRole";
import { ROLE_ACTIONS } from "../types";
import ContentFrame from "./components/ContentFrame";
import { useDialog } from "./hooks";

const RolesBar = () => {
    const { isInitialLoading } = useContext(TableContext);

    const { t } = useTranslation();
    const { toSm } = useMediaQueries();
    const { isOpenDialog, openDialog, closeDialog } = useDialog();
    const { isFeatureSettingsRestricted } = useCompanyLevelSettings();
    const { isCreateRoleNotAllowed, PERMISSIONS } = usePermissions();

    const isRestrictedForNotPremium = isFeatureSettingsRestricted(
        FEATURE_SETTINGS.CustomRoleSupport
    );

    const handleCloseDialog = () => closeDialog(ROLE_ACTIONS.CreateRole);

    return (
        <>
            <ContentFrame>
                <ActionToolbarButtonWrapper
                    customTooltipTitle={
                        isRestrictedForNotPremium
                            ? t(
                                  `Restrictions##${COMPANY_LEVEL_SETTINGS.FeatureSettings}##${FEATURE_SETTINGS.CustomRoleSupport}##create role`
                              )
                            : undefined
                    }
                    permissionName={PERMISSIONS.RoleCreate}
                >
                    <Button
                        fullWidth={toSm}
                        hasRectangleLoader={toSm && isInitialLoading}
                        variant={BUTTON_VARIANTS.TextOnly}
                        size={BUTTON_SIZES.Small}
                        color={BUTTON_COLORS.Primary}
                        disabled={
                            isRestrictedForNotPremium || isCreateRoleNotAllowed
                        }
                        onClick={() => openDialog(ROLE_ACTIONS.CreateRole)}
                    >
                        {t("Button##create role")}
                    </Button>
                </ActionToolbarButtonWrapper>
            </ContentFrame>

            <CreateRole
                isOpen={isOpenDialog[ROLE_ACTIONS.CreateRole]}
                close={handleCloseDialog}
            />
        </>
    );
};

export default RolesBar;
